// カテゴリーごとの定数定義
export const CATEGORIES = {
    NEW_MANSION: "new_mansion", // 新築マンション
    USED_MANSION: "used_mansion", // 中古マンション
    HOUSE: "house", // 戸建て
    NEW_HOUSE: "new_house", // 新築戸建て
    USED_HOUSE: "used_house", // 中古戸建て
    LAND: "land", // 土地
    INVEST: "invest", // 事業用
};
// マップの初期設定（最後の砦）。
// 都道府県版では config('site.areas.*.map')（県庁所在地）を meta 経由で受け取って上書きするので、
// ここが実際に使われるのは総合版・エリア未確定のときだけ
export const MAP_DEFAULT_CONFIG = {
    center: { lat: 34.3853, lng: 132.4553 }, // 広島県広島市中区付近
    zoom: 12,
    mapTypeControl: false,
    streetViewControl: false,
    fullscreenControl: false,
};
// 対象物件を囲む範囲へ寄せるときの余白（px）。
// ピンは下端中央がアンカーなので、上側に少し多めに取って端のピンが切れないようにする
export const MAP_FIT_BOUNDS_PADDING = { top: 72, right: 48, bottom: 48, left: 48 };
// 初期中心を決めるとき「密集している」とみなす半径（m）。
// 中心のズームは県庁所在地と同じ 12 のまま。ズーム12は緯度36度付近で約31m/px、
// 幅375〜390pxのスマホなら横に約12km映り、中心から左右の端まではそれぞれ約6km。
// 半径5kmで数えておけば、選んだ密集がスマホの画面幅にほぼ収まる
export const DENSEST_RADIUS_METERS = 5000;
// カテゴリーごとのマーカー色定義
export const MARKER_COLORS = {
    [CATEGORIES.NEW_MANSION]: "#FF8147CC", // 新築マンション
    [CATEGORIES.USED_MANSION]: "#FF8147CC", // 中古マンション
    [CATEGORIES.HOUSE]: "#007AFF", // 戸建て
    [CATEGORIES.NEW_HOUSE]: "#007AFF", // 新築戸建て
    [CATEGORIES.USED_HOUSE]: "#007AFF", // 中古戸建て
    [CATEGORIES.LAND]: "#008009CC", // 土地
    [CATEGORIES.INVEST]: "#6B7280", // 事業用
};
